// Centralized env var access with strict validation
// In CRA (react-scripts), values come from .env.development/.env.production and overrides from .env.local.
const readEnv = (keys: string[]): string | undefined => {
  for (const k of keys) {
    const v = (process.env as any)[k];
    if (typeof v === "string" && v.trim() !== "") return v;
  }
  return undefined;
};

const readEnvNumber = (keys: string[], fallback: number): number => {
  const raw = readEnv(keys);
  if (raw == null) return fallback;
  const n = Number(raw);
  return Number.isFinite(n) ? n : fallback;
};

export const getEnvVar = (keys: string[] | string): string => {
  const arr = Array.isArray(keys) ? keys : [keys];
  const value = readEnv(arr);
  if (!value) {
    throw new Error(`Missing required environment variable: ${arr.join(" or ")}`);
  }
  return value;
};

/**
 * Canonical backend base URL.
 * Prefer NEXT_PUBLIC_MKS_BACKEND_URL so the same key works across tooling.
 * Back-compat: accept REACT_APP_MKS_BACKEND_URL / REACT_APP_BASE_URL.
 */
export const MKS_BACKEND_URL = getEnvVar([
  "NEXT_PUBLIC_MKS_BACKEND_URL",
  "REACT_APP_MKS_BACKEND_URL",
  "REACT_APP_BASE_URL",
]);

// Optional public configs
export const MKS_AUTH_SECRET = readEnv(["NEXT_PUBLIC_MKS_AUTH_SECRET", "REACT_APP_MKS_AUTH_SECRET"]) || "";
export const MKS_CLIENT_ID = readEnv(["NEXT_PUBLIC_MKS_CLIENT_ID", "REACT_APP_MKS_CLIENT_ID"]) || "";
export const MKS_API_KEY = readEnv(["NEXT_PUBLIC_MKS_API_KEY", "REACT_APP_MKS_API_KEY"]) || "";

// Matrimony
export const MKS_DAILY_INTEREST_LIMIT = readEnvNumber(
  ["NEXT_PUBLIC_MKS_DAILY_INTEREST_LIMIT", "REACT_APP_MKS_DAILY_INTEREST_LIMIT"],
  5
);
